import React from 'react';
import { AccordionContext } from './accordion-context';
import { StyledHeader, StyledIconPlus } from './styles';

export const AccordionHeader: React.FC<AccordionHeaderProps> = ({
  children,
  onClick,
}) => {
  const { disabled, expanded, toggle, id } = React.useContext(AccordionContext);

  const handleChange = (event: React.MouseEvent<HTMLElement>) => {
    if (!disabled) {
      toggle(event);

      if (onClick) {
        onClick(event);
      }
    }
  };

  return (
    <StyledHeader
      disabled={disabled}
      onClick={handleChange}
      aria-expanded={expanded}
      role="button"
      aria-controls={`accordion-content${id}`}
      id={`accordion-header${id}`}
    >
      <StyledIconPlus expanded={expanded} />
      {children}
    </StyledHeader>
  );
};

interface AccordionHeaderProps {
  onClick?: React.MouseEventHandler<HTMLElement>;
  children: React.ReactChild | React.ReactFragment | React.ReactPortal;
}
